import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement, LightDomStyles } from '@phase2/outline-core';
import componentStyles from './outline-utility-nav.css.lit';

/**
 * The OutlineUtilityNav component
 * @element outline-utility-nav
 */
@customElement('outline-utility-nav')
export class OutlineUtilityNav extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`
      <nav class="utility-nav-container">
        <div class="utility-nav-links-container">
          <slot name="links"></slot>
        </div>
      </nav>
    `;
  }
}
